import { render } from "./FooterNavbar.vue?vue&type=template&id=73d73d5d&scoped=true"
const script = {}

import "./FooterNavbar.vue?vue&type=style&index=0&id=73d73d5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d73d5d"]])

export default __exports__